import React, { useState } from 'react';
import './LandingContactSection.css';

function LandingContactSection({ onSubmitEndpoint = '/api/landing-contact-form' }) {
 const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState({
    submitting: false,
    success: null,
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus({ submitting: true, success: null, message: '' });

  try {
    const response = await fetch(onSubmitEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    // Check data.msg instead of data.success
    if (response.ok && data.msg === 'success') {
      setStatus({
        submitting: false,
        success: true,
        message: 'Thank you! Your message has been sent.',
      });
      setFormData({ name: '', email: '', message: '' });
    } else {
      setStatus({
        submitting: false,
        success: false,
        message: 'Something went wrong. Please try again.',
      });
    }
  } catch (err) {
    setStatus({
      submitting: false,
      success: false,
      message: 'Network error. Please try again later.',
    });
  }
};

  return (
    <section className="ttc-contact-section py-5">
      <div className="container py-md-4">
        <div className="row g-4 g-lg-5 align-items-start">
          
          {/* Left Column: Contact Details */}
          <div className="col-12 col-lg-6">
            
            {/* Tag / Badge */}
            <div className="ttc-contact-pill-badge mb-3">
              <span>&rarr; Contact us &larr;</span>
            </div>

            {/* Section Heading */}
            <h2 className="ttc-contact-heading mb-3">
              We&apos;re here when <i>you need us</i>
            </h2>

            {/* Subtitle */}
            <p className="ttc-contact-subtext mb-4">
              Visit the campus, call our emergency desk, or send a message. Our care coordinators respond within a few hours on working days.
            </p>

            {/* Info Cards Stack */}
            <div className="d-flex flex-column gap-3 mt-4">
              
              {/* Address Card */}
              <div className="ttc-info-card p-3 rounded-4 d-flex align-items-center gap-3">
                <div className="ttc-info-icon-box rounded-circle d-flex align-items-center justify-content-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2185e8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div>
                  <span className="ttc-info-label text-uppercase d-block">ADDRESS</span>
                  <p className="ttc-info-value mb-0">
                    55 Avenue Road, Suite 2000, East Tower Toronto, ON, Canada, M5R 3L2
                  </p>
                </div>
              </div>

              {/* Phone Card (Clickable tel link) */}
              <a 
                href="tel:416-849-5555" 
                className="ttc-info-card ttc-info-link p-3 rounded-4 d-flex align-items-center gap-3 text-decoration-none"
              >
                <div className="ttc-info-icon-box rounded-circle d-flex align-items-center justify-content-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2185e8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div>
                  <span className="ttc-info-label text-uppercase d-block">PHONE</span>
                  <p className="ttc-info-value fw-semibold mb-0">416-849-5555</p>
                </div>
              </a>

              {/* Email Card (Clickable mailto link) */}
              <a 
                href="mailto:info@thetorontoclinic.com" 
                className="ttc-info-card ttc-info-link p-3 rounded-4 d-flex align-items-center gap-3 text-decoration-none"
              >
                <div className="ttc-info-icon-box rounded-circle d-flex align-items-center justify-content-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2185e8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div>
                  <span className="ttc-info-label text-uppercase d-block">EMAIL</span>
                  <p className="ttc-info-value fw-semibold mb-0">info@thetorontoclinic.com</p>
                </div>
              </a>

              {/* Hours Card */}
              <div className="ttc-info-card p-3 rounded-4 d-flex align-items-center gap-3">
                <div className="ttc-info-icon-box rounded-circle d-flex align-items-center justify-content-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2185e8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
                <div>
                  <span className="ttc-info-label text-uppercase d-block">HOURS</span>
                  <p className="ttc-info-value fw-medium mb-0">Open 24 Hours · Emergency Always Ready</p>
                </div>
              </div>

            </div>
          </div>

          {/* Right Column: Interactive Form */}
          <div className="col-12 col-lg-6">
            <div className="ttc-contact-form-card p-4 p-md-5 rounded-5 bg-white shadow-sm">
              <h3 className="ttc-form-title mb-1">Send us a message</h3>
              <p className="ttc-form-subtitle mb-4">We&apos;ll get back to you as soon as possible.</p>

              {status.message && (
                <div className={`alert ${status.success ? 'alert-success' : 'alert-danger'} py-2 px-3 mb-4 rounded-3 small`}>
                  {status.message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label ttc-input-label mb-1">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control ttc-input-field rounded-3"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label ttc-input-label mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control ttc-input-field rounded-3"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="message" className="form-label ttc-input-label mb-1">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className="form-control ttc-input-field rounded-3"
                    placeholder="How can we help?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={status.submitting}
                  className="btn ttc-submit-btn w-100 py-3 rounded-3 text-white fw-semibold"
                >
                  {status.submitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default LandingContactSection;